import { createFileRoute } from '@tanstack/react-router';

import { WynikView } from '../../raporty/projekty/WynikView';

export const Route = createFileRoute('/raporty/wynik-projektow')({
  component: WynikView,
});
